import script from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardPage.vue?vue&type=style&index=0&id=e39dd092&scope=true&lang=css"

const __exports__ = script;

export default __exports__